import {Upload,Button} from 'antd';
import { UploadOutlined } from '@ant-design/icons';


export default function UploadButton({cb}){

    return(
        <>
            <div>
            <Upload
            accept=".xls,.xlss"
                >
                <Button>
                <UploadOutlined/>
                Import
                </Button>
            </Upload>
        </div>
        </>
    )
}